import { generatePath, useNavigate } from "react-router-dom";
import { MainRoutes } from "../../../../common/router/MainRouter.types";
import useScanModalTabs from "ui/transactions/containers/ScanModal/hooks/useScanModalTabs";
import useGetBalance from "ui/wallet/query/useGetBalance";
import { QRCodeDto } from "ui/transactions/utils/QRCodeDto";

export default function useQrScanNavigation() {
    const { data: balance = "0" } = useGetBalance();
    const scanModalTabs = useScanModalTabs();
    const navigate = useNavigate();

    function navigateToTransactionTab(qrCode: string | undefined) {
        if (qrCode) {
            const path = generatePath(MainRoutes.SEND_AND_RECEIVE, { type: scanModalTabs[0].path });
            const pathToNavigate = QRCodeDto.generatePaymentUrl(qrCode, balance, path);
            navigate(pathToNavigate);
        }
    }

    return { navigateToTransactionTab };
}
